export class FeeScheduleDeleteCommand{
    feeScheduleId:string;

    constructor(feeScheduleId:string){
        this.feeScheduleId = feeScheduleId;
    }
}